const DEFAULT_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";

function buildUrl(baseUrl, path) {
  const normalizedBase = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}

export async function apiFetch(path, options = {}) {
  return fetch(buildUrl(DEFAULT_API_BASE_URL, path), options);
}
